import { orlisLogoUrl } from "@/orlisAssets";

export function OrlisLogo({ size = "small", testId }) {
  return (
    <span className={`logo-lockup logo-lockup-${size}`}>
      <span className="logo-aura" aria-hidden="true">
        <span className="logo-disc">
          <img src={orlisLogoUrl} alt="Orlis AI official logo mark" data-testid={testId} />
        </span>
      </span>
      <span className="logo-wordmark">ORLIS <em>AI</em></span>
    </span>
  );
}
